import { render } from "./HorizontalNavMenuHeaderGroup.vue?vue&type=template&id=2f188c32"
import script from "./HorizontalNavMenuHeaderGroup.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuHeaderGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__